export default "__VITE_ASSET__CCu8j5RT__"